module.exports = __webpack_public_path__ + "img/scb.ce154a4a.jpg";